import styled from 'styled-components';
export const BackdropContainer = styled.div`
  .backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.75);
    z-index: 6;
    opacity: 0;
    pointer-events: none;
    transition: all 0.8s ease;
  }

  .show {
    opacity: 1;
    pointer-events: all;
  }
`;
